<template>
  <div>
    <p class="m-2">みんなの問いを検索する</p>
    <div class="input-group mb-3">
      <input
        type="text"
        class="form-control"
        placeholder="Enter Searching Target"
        aria-label="Recipient's username"
        aria-describedby="button-addon2"
        v-model="searchTarget"
      />
      <div class="input-group-append">
        <button
          class="btn btn-outline-secondary"
          type="button"
          id="button-addon2"
          v-on:click="searchQuestion()"
        >
          検索
        </button>
      </div>
    </div>
    <div class="qestions-wrapper">
      <div v-for="(question, index) in questions" v-bind:key="index">
        <QuestionCard :question="question" />
      </div>
    </div>
    <b-button @click="fetchNextQuestions" v-if="!finished">
      もっと見る
    </b-button>
  </div>
</template>

<script>
// @ is an alias to /src
import { db } from "@/firebase";
import QuestionCard from "@/components/QuestionCard.vue";

export default {
  name: "List",
  data: function() {
    return {
      questions: [],
      lastQuestionCreatedAt: "",
      searchTarget: "",
      finished: false
    };
  },
  components: {
    QuestionCard
  },
  methods: {
    fetchData() {
      db.collection("questions")
        .orderBy("createdAt", "desc")
        .limit(12)
        .get()
        .then(snapshots => {
          snapshots.docs.forEach(snapshot => {
            const questionData = snapshot.data();
            questionData.id = snapshot.id;
            this.questions.push(questionData);
          });
          this.lastQuestionCreatedAt = snapshots.docs[
            snapshots.docs.length - 1
          ].data().createdAt;
        });
    },
    fetchNextQuestions() {
      db.collection("questions")
        .orderBy("createdAt", "desc")
        .startAfter(this.lastQuestionCreatedAt)
        .limit(12)
        .get()
        .then(snapshots => {
          if (snapshots.docs.length < 12) {
            this.finished = true;
          }
          snapshots.docs.forEach(snapshot => {
            const questionData = snapshot.data();
            questionData.id = snapshot.id;
            this.questions.push(questionData);
          });
          this.lastBookCreatedAt = snapshots.docs[
            snapshots.docs.length - 1
          ].data().createdAt;
        });
    },
    searchQuestion() {
      this.questions = [];
      db.collection("questions")
        .orderBy("text")
        .startAt(this.searchTarget)
        .endAt(this.searchTarget + "\uf8ff")
        .get()
        .then(docs => {
          docs.forEach(doc => {
            const question = doc.data();
            question.id = doc.id;
            this.questions.push(question);
          });
          this.finished = true;
        });
    }
  },
  created() {
    this.fetchData();
  }
};
</script>
